/* eslint-disable */
import React from "react";
import { ThemeContext, themes } from "../../themes/ThemeContext";

function UnlimitedTraffic() {
  const theme = React.useContext(ThemeContext);
  return (
    <div
      className="m-2 md:m-10 mt-24 p-2 md:p-10 rounded-md overflow-hidden min-h-screen"
      style={{ color: theme.colors.text.primary }}
    >
      <div className="">
        <div className="pageTitle text-3xl font-semibold">
          UNLIMITED TRAFFIC
        </div>
        <div className="tag text-md mt-2 text-xs font-thin">
          {/* Update your Profile Details */}
        </div>
      </div>
      <div className="text-lg w-1/2" style={{ lineHeight: "50px" }}>
        Hey there,
        <br />
        Thank you for your patronage.
        <br />
        To enable you to share our pool of 100% buyer traffic with you, kindly
        watch this video and revert with your Fb pixel{" "}
        <a
          href="https://m.youtube.com/watch?v=jSBKCbIS_sg"
          className="text-blue-500"
        >
          https://m.youtube.com/watch?v=jSBKCbIS_sg
        </a>
        .
        <br />
        <div className="font-semibold">Thank you</div>
      </div>
    </div>
  );
}

export default UnlimitedTraffic;
